// @flow

import { type Receipt } from '@tectonics/prs/receipts';
import { type Fx } from '@tectonics/prs/money';

export function getFX(receipt: Receipt): Fx {
  return receipt.fx;
}
